import { Card, CardContent } from "../ui/card";
import AppInstallDialog from "../AppInstallDialog";
import { useTranslation } from "@/hooks/useTranslation";
import lounge from "../../assets/lounge.avif";
import { PageType } from "../PageType";

export default function OnboardingWaitlisted() {
  const t = useTranslation();

  return (
    <>
      <div className="dark flex flex-col min-w-[320px] w-full max-w-lg mx-auto gap-y-4 px-2">
        <Card className="rounded-3xl">
          <CardContent className="flex flex-col w-full pt-6">
            <img src={lounge} className="w-[90vw] max-w-sm mx-auto" />
            <div className="text-2xl font-semibold tracking-tight text-gray-200 my-4">
              {t.WAITLISTED_PAGE.TITLE}
            </div>
            <h2 className="text-sm text-[#9D9D9D]">
              {t.WAITLISTED_PAGE.DESCRIPTION}
            </h2>
          </CardContent>
        </Card>
      </div>
      <AppInstallDialog pageType={PageType.APPLIED} />
    </>
  );
}
